<template>
  <div class="box_bain">
    <!-- <span class="span_1">
      <img class="img_1" src="@/assets/images/news_ico_1.png" />
      <img class="img_2" src="@/assets/images/news_ico_1.png" />
      {{ lange == "ch" ? "最新资讯" : "Latest information" }}
    </span> -->
  </div>
</template>

<script>
export default {
  name: "NewsBannerText",
  components: {},
  data() {
    return {
      lange: this.$cookies.getCookie("language"),
    };
  },
  created() {},
  props: [],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box_bain {
  width: 100%;
  height: 100%;
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  text-align: center;
}
.span_1 {
  display: inline-block;
  font-size: 36px;
  color: #fff;
  position: relative;
  padding: 0 30%;
  margin-top: 6%;
}
.span_1 > img {
  width: 30%;
  height: 2px;
  display: block;
  position: absolute;
  top: 50%;
}
.img_1 {
  left: 0;
}
.img_2 {
  right: 0;
}
@media only screen and (max-width: 425px) {
  .span_1 {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Banner/component/NewsBannerText.vue